import axios from "axios"
import React, { Suspense, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/Layout"
import Pagination from "../components/Pagination"
import PortfolioView from "../components/PortfolioView"
import Sectiontitle from "../components/Sectiontitle"
import Spinner from "../components/Spinner"

interface PortfolioItem {
  id: string | number
  [key: string]: unknown
}

const Portfolio: React.FC = () => {
  const [portfolio, setPortfolio] = useState<PortfolioItem[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [portfolioPerPage] = useState(9)

  useEffect(() => {
    let mounted = true
    axios.get<PortfolioItem[]>("/api/portfolio").then((response) => {
      if (mounted) {
        setPortfolio(response.data)
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  const indexOfLastPortfolio = currentPage * portfolioPerPage
  const indexOfFirstPortfolio = indexOfLastPortfolio - portfolioPerPage
  const currentPortfolio = portfolio.slice(
    indexOfFirstPortfolio,
    indexOfLastPortfolio
  )

  const paginate = (e: React.MouseEvent<HTMLAnchorElement>, pageNumber: number) => {
    e.preventDefault()
    setCurrentPage(pageNumber)
  }

  return (
    <Layout>
      <Helmet>
        <title>Portfolio - Nathan Hensher</title>
        <meta
          name="description"
          content="Nathan Hensher - Javascript Engineer - Portfolio"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-about mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="Portfolio" />
            <PortfolioView portfolio={currentPortfolio as any} />
            {!(portfolio.length > portfolioPerPage) ? null : (
              <Pagination
                className="mt-50"
                itemsPerPage={portfolioPerPage}
                totalItems={portfolio.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </Suspense>
    </Layout>
  )
}

export default Portfolio
